var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99805 13.6855C9.08762 13.6855 9.16113 13.7585 9.16113 13.8486C9.161 13.9387 9.08754 14.0107 8.99805 14.0107C8.90877 14.0105 8.83607 13.9385 8.83594 13.8486C8.83594 13.7586 8.90868 13.6858 8.99805 13.6855Z",
    fill: "#FEC53D",
    stroke: "#FEC53D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.45898V11.1103",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19504 14.8579L7.36751 2.5092C8.04016 1.16359 9.95983 1.1636 10.6325 2.5092L16.805 14.8579C17.4117 16.0718 16.5293 17.5 15.1725 17.5H2.82748C1.47071 17.5 0.588271 16.0718 1.19504 14.8579Z",
    stroke: "#FEC53D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.f2a444a09be6963893847f906fad774c.svg";
export { ForwardRef as ReactComponent };